import { useState, useCallback, useLayoutEffect } from 'react';
import throttle from 'lodash/throttle';
export function useElementScrollbarWidth(element, onChangeCallback, ...deps) {
    const [scrollbarWidth, setScrollBarWidth] = useState(0);
    const updateScrollbarWidth = useCallback((target) => {
        const _element = target || element;
        if (_element && onChangeCallback) {
            const nextScrollbarWidth = _element.offsetWidth - _element.clientWidth;
            if (nextScrollbarWidth !== scrollbarWidth) {
                if (typeof onChangeCallback === 'function') {
                    onChangeCallback(nextScrollbarWidth);
                }
                setScrollBarWidth(nextScrollbarWidth);
            }
        }
    }, [scrollbarWidth, element, onChangeCallback]);
    const throttledUpdateScrollbarWidth = useCallback(throttle(updateScrollbarWidth, 250, {
        leading: true,
        trailing: true,
    }), [updateScrollbarWidth]);
    useLayoutEffect(updateScrollbarWidth, [updateScrollbarWidth, ...deps]);
    return {
        scrollbarWidth,
        updateScrollbarWidth,
        throttledUpdateScrollbarWidth,
    };
}
//# sourceMappingURL=useElementScrollbarWidth.js.map